// Once-guard: the section emits its own <script defer> tag, so two instances of
// the section on one page load this file twice. Without the guard every listener
// below would be bound twice and each replay would post two messages.
if (!window.__recipeShortsInit) {
  window.__recipeShortsInit = true;

  document.querySelectorAll('.recipe-shorts').forEach((section) => {
    // Filters. Two modes share one mechanism: category pills match a card's
    // data-category; product filters match one handle inside a card's
    // space-separated data-products. The product UI renders the same option
    // list twice (desktop sidebar + mobile <details> dropdown), so pressed
    // state syncs across every button sharing the clicked data-filter value.
    const filterButtons = section.querySelectorAll('.recipe-shorts__filter');
    const cards = section.querySelectorAll('.recipe-shorts__card');
    const dropdown = section.querySelector('.recipe-shorts__filter-dropdown');
    const dropdownCurrent = section.querySelector('.recipe-shorts__dropdown-current');
    filterButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const value = btn.dataset.filter;
        const type = btn.dataset.filterType || 'category';
        filterButtons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filter === value)));
        cards.forEach((card) => {
          if (value === 'all') {
            card.hidden = false;
          } else if (type === 'product') {
            card.hidden = !(card.dataset.products || '').split(' ').includes(value);
          } else {
            card.hidden = card.dataset.category !== value;
          }
        });
        if (dropdownCurrent) dropdownCurrent.textContent = btn.textContent.trim();
        if (dropdown && dropdown.contains(btn) && dropdown.hasAttribute('open')) {
          // Closing the <details> would drop focus to <body>; park it on the
          // summary first so keyboard users stay in place. (The open check
          // keeps a programmatic deep-link click from stealing focus on load.)
          const summary = dropdown.querySelector('summary');
          if (summary) summary.focus();
        }
        if (dropdown) dropdown.removeAttribute('open');
      });
    });

    // Deep link: /pages/recipes?filter=<data-filter value> pre-selects a
    // filter on load by reusing the click handler. Unknown values are ignored.
    const requested = new URLSearchParams(window.location.search).get('filter');
    if (requested && requested !== 'all') {
      const target = Array.from(filterButtons).find((b) => b.dataset.filter === requested);
      if (target) target.click();
    }

    // Thumbnail fallback: Shorts expose frame0.jpg, older uploads only hqdefault.jpg.
    // Swap on error from a data attribute rather than an inline onerror handler, so
    // no video id ever reaches an inline script context. `once` prevents a loop if
    // the fallback 404s too; the equality guard covers a cached-error re-fire.
    section.querySelectorAll('img[data-fallback-src]').forEach((img) => {
      img.addEventListener(
        'error',
        () => {
          if (img.src !== img.dataset.fallbackSrc) img.src = img.dataset.fallbackSrc;
        },
        { once: true }
      );
    });

    // Play on open: DeferredMedia injects the iframe once, and the theme pauses
    // all media when the modal closes. ModalOpener's own click handler runs
    // before this one and loads the media synchronously, so `loaded` is already
    // set even on the first open and the postMessage fires on every open. That
    // is fine: while the player is still initialising the message is dropped and
    // autoplay=1 starts playback; on reopens the message resumes the paused player.
    section.querySelectorAll('modal-opener').forEach((opener) => {
      const button = opener.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(opener.getAttribute('data-modal'));
        if (!modal) return;
        const media = modal.querySelector('deferred-media');
        if (!media || !media.getAttribute('loaded')) return;
        const iframe = media.querySelector('iframe.js-youtube');
        if (!iframe) return;
        setTimeout(() => {
          // The modal can be closed inside this window; resuming would play audio
          // behind a dismissed dialog.
          if (!modal.hasAttribute('open')) return;
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }, 150);
      });
    });
  });
}